import React, { useEffect } from "react";
import CategoryHeader from "../../components/Category/CategoryHeader";
import { Container } from "react-bootstrap";
import ProductDetailsComp from "../../components/Products/ProductDetailsComp";
import RateContainer from "../../components/Rate/RateContainer";
import CardProductContainer from "../../components/Products/CardProductContainer";
import UseViewProductDetails from "../../CustomHooks/Products/UseViewProductDetails";
import UseLogged from "../../CustomHooks/Auth/UseLogged";
import NavBar from "../../components/Layout/NavBar";
import Footer from "../../components/Layout/Footer";
import UseViewSearchProducts from "../../CustomHooks/Products/UseViewSearchProducts";

const ProductDetails = () => {
  const [item, images, categoryName, BrandName, similarProducts, rateValue] = UseViewProductDetails()
  const [isLogin, LogOut, role, token] = UseLogged();
  const [NumberOfPages, AllLoading, SearchLoading, items, onPressPage, searchProductsFunc, onChangeSearchInput, searchInputValue] = UseViewSearchProducts()

  return (
    <>
      <NavBar onChangeSearchInput={onChangeSearchInput} searchInputValue={searchInputValue} />
      <CategoryHeader />
      <Container>
        <ProductDetailsComp />
      </Container>
      <RateContainer item={item} IsLogin={isLogin} role={role} rateValue={rateValue} token={token}/>
      {similarProducts.length >= 1 ? (<CardProductContainer products={similarProducts} title="May you like it" />) : null}
      <Footer />
    </>
  );
};

export default ProductDetails;
